"use strict";
/**
 * After a Nucleus invoice payment is allocated on the ACCREC, move the paid
 * **milestone** amount from contract liability to revenue.
 *
 * Applies to both split-schedule and non-split Nucleus invoices (deferred income on ACCREC).
 *
 * Platform / Nucleus fee is **not** recognized here (HAN-410): it posts as a bank charge at
 * pay-in via RECORD_PLATFORM_CHARGE.
 *
 * **Trigger**: escrow fully released for a Nucleus invoice (split tranche or single invoice).
 *
 * **Idempotency**: `project_split_recognize:{projectInvoiceId}:{suffix}` — one journal per tranche release.
 * Split schedules use narration `Deferred revenue release — {schedule} ({trancheCode})` so each tranche posts separately.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCOUNTING_SPLIT_TRANCHE_RECOGNITION_SYNC_IDEMPOTENCY_PREFIX = exports.ACCOUNTING_SYNC_OPERATION_RECOGNIZE_SPLIT_TRANCHE_REVENUE = void 0;
exports.buildAccountingSplitTrancheRecognitionIdempotencyKey = buildAccountingSplitTrancheRecognitionIdempotencyKey;
exports.parseAccountingSplitTrancheRecognitionIdempotencyKey = parseAccountingSplitTrancheRecognitionIdempotencyKey;
exports.isRecognizeSplitTrancheRevenueAccountingSyncOp = isRecognizeSplitTrancheRevenueAccountingSyncOp;
exports.ACCOUNTING_SYNC_OPERATION_RECOGNIZE_SPLIT_TRANCHE_REVENUE = "RECOGNIZE_SPLIT_TRANCHE_REVENUE";
exports.ACCOUNTING_SPLIT_TRANCHE_RECOGNITION_SYNC_IDEMPOTENCY_PREFIX = "project_split_recognize:";
const PROJECT_SPLIT_RECOGNIZE_KEY = /^project_split_recognize:([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}):(.+)$/i;
function buildAccountingSplitTrancheRecognitionIdempotencyKey(projectInvoiceId, idempotencySuffix) {
    return `${exports.ACCOUNTING_SPLIT_TRANCHE_RECOGNITION_SYNC_IDEMPOTENCY_PREFIX}${projectInvoiceId}:${idempotencySuffix}`;
}
function parseAccountingSplitTrancheRecognitionIdempotencyKey(idempotencyKey) {
    const match = idempotencyKey.match(PROJECT_SPLIT_RECOGNIZE_KEY);
    if (!match) {
        return null;
    }
    return { projectInvoiceId: match[1], idempotencySuffix: match[2] };
}
function isRecognizeSplitTrancheRevenueAccountingSyncOp(operation) {
    return operation === exports.ACCOUNTING_SYNC_OPERATION_RECOGNIZE_SPLIT_TRANCHE_REVENUE;
}
